import {
    useQueryClient,
    useMutation,
    UseMutationResult,
} from '@tanstack/react-query'
import { IRelation } from '../../interfaces'
import { updateRelation } from '../../../../services/dtServices'

export const useUpdateRelation = (
    entityTemplateId: string,
    orgId: string,
): UseMutationResult<
    Awaited<ReturnType<typeof updateRelation>>,
    Error,
    IRelation
> => {
    const queryClient = useQueryClient()
    return useMutation({
        mutationFn: (relation: IRelation) => {
            return updateRelation(entityTemplateId, orgId, relation)
        },
        //client side optimistic update
        onMutate: (newRelationInfo: IRelation) => {
            queryClient.setQueryData(
                ['relations', entityTemplateId, orgId],
                (relations: IRelation[]) =>
                    relations?.map((relation: IRelation) =>
                        relation.id === newRelationInfo.id
                            ? newRelationInfo
                            : relation,
                    ),
            )
        },
        //refetch relations after mutation
        onSettled: () =>
            queryClient.invalidateQueries({
                queryKey: ['relations', entityTemplateId],
            }),
    })
}
